// services/complaintsCountService.js

import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../network/firebaseConfig";

// Cache for complaints count + raw data
let countCache = {
    total: 0,
    active: 0,
    pending: 0,
    inOperation: 0,
    paused: 0,
    completed: 0,
    urgent: 0,
    delayed: 0,
    complaints: [],          // 👈 new: store all complaints
    lastUpdated: null,
    listeners: []
};

// Subscribe to complaints count with real-time updates
export const subscribeToComplaintsCount = (callback) => {
    countCache.listeners.push(callback);

    if (countCache.lastUpdated) {
        callback({ ...countCache });
    }

    const unsubscribe = onSnapshot(
        collection(db, "complaints"),
        (snapshot) => {
            // 👇 Store all complaints first
            const allComplaints = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            countCache.complaints = allComplaints;

            let total = 0;
            let active = 0;
            let pending = 0;
            let inOperation = 0;
            let paused = 0;
            let completed = 0;
            const now = new Date();

            // We'll reuse the same loops but now we have allComplaints
            allComplaints.forEach((doc) => {
                const data = doc;
                const status = data.status || 'pending';
                total++;
                if (status === 'pending') pending++;
                else if (status === 'in-operation') inOperation++;
                else if (status === 'paused') paused++;
                else if (status === 'completed') completed++;

                if (status !== 'completed' && status !== 'paused') active++;

                if (status === 'in-operation') {
                    const hoursMatch = data.approximateResolveTime?.match(/(\d+)/);
                    if (hoursMatch && data.updatedAt) {
                        const totalHours = parseInt(hoursMatch[1]);
                        const updatedAt = data.updatedAt?.toDate?.() || new Date(data.updatedAt);
                        const resolveTime = new Date(updatedAt.getTime() + totalHours * 60 * 60 * 1000);
                        if (now > resolveTime) {
                            if (!countCache._delayedIds) countCache._delayedIds = new Set();
                            countCache._delayedIds.add(doc.id);
                        } else {
                            const remaining = resolveTime - now;
                            const hoursRemaining = remaining / (1000 * 60 * 60);
                            if (hoursRemaining < 1) {
                                if (!countCache._urgentIds) countCache._urgentIds = new Set();
                                countCache._urgentIds.add(doc.id);
                            }
                        }
                    }
                }
            });

            countCache.total = total;
            countCache.active = active;
            countCache.pending = pending;
            countCache.inOperation = inOperation;
            countCache.paused = paused;
            countCache.completed = completed;
            countCache.urgent = countCache._urgentIds?.size || 0;
            countCache.delayed = countCache._delayedIds?.size || 0;
            countCache.lastUpdated = new Date();

            countCache._delayedIds = new Set();
            countCache._urgentIds = new Set();

            countCache.listeners.forEach(listener => {
                listener({ ...countCache });
            });
        },
        (error) => {
            console.error("Error subscribing to complaints count:", error);
        }
    );

    return () => {
        countCache.listeners = countCache.listeners.filter(
            listener => listener !== callback
        );
        if (countCache.listeners.length === 0) {
            unsubscribe();
        }
    };
};

// 👇 New: get the cached complaints array
export const getCachedComplaints = () => {
    return countCache.complaints || [];
};

// Existing getters...
export const getCachedComplaintsCount = () => {
    return countCache.lastUpdated ? { ...countCache } : null;
};

export const getActiveComplaintsCount = () => countCache.inOperation || 0;
export const getTotalComplaintsCount = () => countCache.total || 0;
export const getPendingComplaintsCount = () => countCache.pending || 0;
export const getDelayedComplaintsCount = () => countCache.delayed || 0;
export const getUrgentComplaintsCount = () => countCache.urgent || 0;

export const clearComplaintsCountCache = () => {
    countCache = {
        total: 0,
        active: 0,
        pending: 0,
        inOperation: 0,
        paused: 0,
        completed: 0,
        urgent: 0,
        delayed: 0,
        complaints: [],
        lastUpdated: null,
        listeners: []
    };
};

// // services/complaintsCountService.js

// import { collection, onSnapshot } from "firebase/firestore";
// import { db } from "../network/firebaseConfig";

// // Cache for complaints count
// let countCache = {
//     total: 0,
//     active: 0,
//     pending: 0,
//     inOperation: 0,
//     paused: 0,
//     completed: 0,
//     urgent: 0,
//     delayed: 0,
//     lastUpdated: null,
//     listeners: []
// };

// // Subscribe to complaints count with real-time updates
// export const subscribeToComplaintsCount = (callback) => {
//     // Add callback to listeners
//     countCache.listeners.push(callback);

//     // If we already have data, call callback immediately
//     if (countCache.lastUpdated) {
//         callback({ ...countCache });
//     }

//     // Create a single listener for all complaints
//     const unsubscribe = onSnapshot(
//         collection(db, "complaints"),
//         (snapshot) => {
//             let total = 0;
//             let active = 0;
//             let pending = 0;
//             let inOperation = 0;
//             let paused = 0;
//             let completed = 0;
//             const now = new Date();

//             snapshot.docs.forEach((doc) => {
//                 const data = doc.data();
//                 const status = data.status || 'pending';

//                 total++;

//                 // Count by status
//                 if (status === 'pending') pending++;
//                 else if (status === 'in-operation') inOperation++;
//                 else if (status === 'paused') paused++;
//                 else if (status === 'completed') completed++;

//                 // Active = not completed and not paused
//                 if (status !== 'completed' && status !== 'paused') {
//                     active++;
//                 }

//                 // Check if delayed or urgent (only for in-operation)
//                 if (status === 'in-operation') {
//                     const hoursMatch = data.approximateResolveTime?.match(/(\d+)/);
//                     if (hoursMatch && data.updatedAt) {
//                         const totalHours = parseInt(hoursMatch[1]);
//                         const updatedAt = data.updatedAt?.toDate?.() || new Date(data.updatedAt);
//                         const resolveTime = new Date(updatedAt.getTime() + totalHours * 60 * 60 * 1000);

//                         if (now > resolveTime) {
//                             // Delayed
//                             if (!countCache._delayedIds) countCache._delayedIds = new Set();
//                             countCache._delayedIds.add(doc.id);
//                         } else {
//                             const remaining = resolveTime - now;
//                             const hoursRemaining = remaining / (1000 * 60 * 60);
//                             if (hoursRemaining < 1) {
//                                 // Urgent
//                                 if (!countCache._urgentIds) countCache._urgentIds = new Set();
//                                 countCache._urgentIds.add(doc.id);
//                             }
//                         }
//                     }
//                 }
//             });

//             // Update cache
//             countCache.total = total;
//             countCache.active = active;
//             countCache.pending = pending;
//             countCache.inOperation = inOperation;
//             countCache.paused = paused;
//             countCache.completed = completed;
//             countCache.urgent = countCache._urgentIds?.size || 0;
//             countCache.delayed = countCache._delayedIds?.size || 0;
//             countCache.lastUpdated = new Date();

//             // Clear temporary sets
//             countCache._delayedIds = new Set();
//             countCache._urgentIds = new Set();

//             // Notify all listeners
//             countCache.listeners.forEach(listener => {
//                 listener({ ...countCache });
//             });
//         },
//         (error) => {
//             console.error("Error subscribing to complaints count:", error);
//         }
//     );

//     // Return unsubscribe function
//     return () => {
//         countCache.listeners = countCache.listeners.filter(
//             listener => listener !== callback
//         );
//         if (countCache.listeners.length === 0) {
//             unsubscribe();
//         }
//     };
// };

// // Get cached count without subscribing
// export const getCachedComplaintsCount = () => {
//     return countCache.lastUpdated ? { ...countCache } : null;
// };

// // Get specific count types
// export const getActiveComplaintsCount = () => countCache.inOperation || 0;
// export const getTotalComplaintsCount = () => countCache.total || 0;
// export const getPendingComplaintsCount = () => countCache.pending || 0;
// export const getDelayedComplaintsCount = () => countCache.delayed || 0;
// export const getUrgentComplaintsCount = () => countCache.urgent || 0;

// // Clear cache (useful for testing)
// export const clearComplaintsCountCache = () => {
//     countCache = {
//         total: 0,
//         active: 0,
//         pending: 0,
//         inOperation: 0,
//         paused: 0,
//         completed: 0,
//         urgent: 0,
//         delayed: 0,
//         lastUpdated: null,
//         listeners: []
//     };
// };